import styled from 'styled-components';

/**
 * Field rows and their headers share one grid so the six columns stay lined up. The three
 * numeric limits keep their columns even on a text field, where they render empty rather
 * than collapsing the row.
 */
export const StyledFieldGrid = styled.div`
  display: grid;
  grid-template-columns: 1.3fr 1.1fr 1fr 0.9fr 0.9fr 0.9fr 24px;
  gap: 12px;
  align-items: center;
  width: 100%;
`;

export const StyledFieldHeading = styled.span`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.54);
`;

export const StyledToggleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 0 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
`;

/**
 * Holds a grid column open where a control does not apply, so field rows stay lined up
 * with the headings above them.
 */
export const StyledEmptyCell = styled.span``;
